import { Component, ElementRef, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { InvoiceListIssuedComponent } from './invoice-list-issued.component';
import { InvoiceService } from './invoice.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { InvoiceModel } from './invoice.model';
import { ContactService } from '../../contact/contact/contact.service';
import { ContactBankAccountService } from '../../contact/contactbankaccounts/contactbankaccount.service';
import { consts } from '../../../consts';
import { ConceptService } from '../../concept/concept/concept.service';
import { PreinvoiceService } from '../preinvoice/preinvoice.service';
import { ConceptModel } from '../../concept/concept/concept.model';

@Component({
    selector: 'convfact-invoicerectification',
    templateUrl: './invoice-dialog-rectification.component.html',
    styleUrls: ['./invoice-dialog-rectification.component.css'],
    standalone: false
})

export class InvoiceDialogRectificationComponent {

    uid: string = this.data.uid;
    invoice: InvoiceModel = this.data.invoice;
    errors: string[] = [];
    error: boolean = false;
    ready: boolean = false;
    doing: boolean = false;

    constructor(
        public dialogRef: MatDialogRef<InvoiceListIssuedComponent>,
        public invoiceService: InvoiceService,
        public conceptService: ConceptService,
        public preinvoiceService: PreinvoiceService,
        public contactService: ContactService,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public contactBankAccountService: ContactBankAccountService,
        private snackBar: MatSnackBar
    ) { }

    //------------ Conceptos con números de serie ----------------//	
    conceptSerialNumber(invoice: InvoiceModel) {
        this.preinvoiceService.loadData(invoice.uid).then(invoice => {
            this.conceptService.getListSerialNumbers().then(conceptsWithSerialNumbers => {
                const concepts: ConceptModel[] = conceptsWithSerialNumbers;
                let conceptUid: string;
                if (concepts.length > 0) {
                    concepts.forEach(concept => {
                        invoice.invoiceLines.forEach(invoiceLine => {
                            if (invoiceLine.product.includes(concept.name)) {
                                console.log("Concepto con número de serie encontrado en factura");
                                conceptUid = concept.uid;
                                this.conceptService.getSerialNumbers(concept.uid).then(serialNumbers => {
                                    serialNumbers.forEach(serialNumber => {
                                        if (invoiceLine.product.includes(serialNumber.serialNumber)) {
                                            console.log("Número de serie encontrado en factura");
                                            serialNumber.invoiceUid = "";
                                            serialNumber.invoiceNumber = "";
                                            this.conceptService.modifySerialNumbers(serialNumber, concept.uid).then(response => {
                                                console.log("Número de serie liberado");
                                                this.conceptService.loadData(conceptUid).then(concept => {
                                                    concept.units = concept.units + 1;
                                                    this.conceptService.editData(conceptUid, concept).then(response => {
                                                        console.log("Concepto actualizado");
                                                    });
                                                });
                                            });
                                        }
                                    });
                                });
                            }
                        });
                    });
                }
            });
        });
    }
    //------------ Fin Conceptos con números de serie ----------------//

    rectification(): void {
        this.doing = true;
        this.dialogRef.disableClose = true;
        this.invoiceService.rectify(this.uid, consts.EMPTY_GUID).then(() => {
            this.invoiceService.loadData(this.uid).then(response => {
                const invoice = response;
                this.conceptSerialNumber(invoice);
            })
            this.dialogRef.close(true);
        }).catch(error => {
            this.doing = false;
            this.dialogRef.disableClose = false;
            const message = error && error.error && error.error.message ? error.error.message : 'No se pudo rectificar la factura';
            this.snackBar.open(message, '', { duration: 5000 });
        })
    }

    closeDialog() {
        if (this.doing) return;
        this.dialogRef.close(false);
    }

}
